  @if (isRequester){
    <h2 class="subtitle">
      {{ "order-details.requestedItems" | translate }}
    </h2>
  }
  <div class="order-details-container">
    <table mat-table [dataSource]="itemsData" class="orders-table">

      <ng-container matColumnDef="codItem">
        <th class="table-header" mat-header-cell *matHeaderCellDef style="width: 20%;">{{ 'order-details.codItem' | translate }}</th>
        <td mat-cell *matCellDef="let element"> {{ element.itemId }}</td>
      </ng-container>

      <ng-container matColumnDef="partNumber">
        <th class="table-header" mat-header-cell *matHeaderCellDef style="width: 20%;">{{ 'general.partNumber' | translate }}</th>
        <td mat-cell *matCellDef="let element"> {{element.partNumber}}</td>
      </ng-container>

      <ng-container matColumnDef="item">
        <th class="table-header" mat-header-cell *matHeaderCellDef style="width: 20%;">{{ 'general.item' | translate }}</th>
        <td mat-cell *matCellDef="let element"> {{ element.description }}</td>
      </ng-container>

      <ng-container matColumnDef="category">
        <th class="table-header" mat-header-cell *matHeaderCellDef style="width: 20%;">{{ 'order-details.category' | translate }}</th>
        <td mat-cell *matCellDef="let element">{{ element.category }}</td>
      </ng-container>

      <ng-container matColumnDef="manufacturer">
        <th class="table-header" mat-header-cell *matHeaderCellDef style="width: 20%;">{{ 'order-details.manufacturer' | translate }}</th>
        <td mat-cell *matCellDef="let element">{{ element.manufacturer }}</td>
      </ng-container>

      <ng-container matColumnDef="quantity">
        <th class="table-header" mat-header-cell *matHeaderCellDef style="width: 10%;">{{ 'order-details.quantity' | translate }}</th>
        <td mat-cell *matCellDef="let element">{{ element.requestedQuantity }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>
  <p class="text">{{"order-details.costCenter" | translate}}</p>
  <mat-form-field appearance="outline" style="width: 100%">
     <input matInput readonly [value]="itemsData.length > 0 ? itemsData[0].costCenter : ''">
  </mat-form-field>
  <p class="text">{{"order-details.generalObservations" | translate}}</p>
  <mat-form-field appearance="outline" style="width: 100%">
     <input matInput readonly [value]="generalRemarks" placeholder="{{ 'order-details.generalObservations' | translate }}">
  </mat-form-field>
  @if (isRejected) {
    <p class="text">{{ "order-details.rejectionJustification" | translate }}</p>
    <mat-form-field appearance="outline" style="width: 100%">
      <input matInput readonly [value]="rejectionJustification"
             placeholder="{{ 'order-details.rejectionJustification' | translate }}">
    </mat-form-field>
  }
  @if (isCancelled) {
    <p class="text">{{ "order-details.cancellationJustification" | translate }}</p>
    <mat-form-field appearance="outline" style="width: 100%">
      <input matInput readonly [value]="cancelledJustification"
             placeholder="{{ 'order-details.cancellationJustification' | translate }}">
    </mat-form-field>
  }




